<template>
<div>
<transition name="fade">
<animated-loader v-if="showLoader"></animated-loader>

</transition>


    <transition name="fade">
<div class="instructions" id="how-to" v-if="showInstructions">
  
  <div class="row">
    <div class="col s10 m4 offset-m4 offset-s1">
<div class="info-box card-panel">

   <icon-scroll v-if="!mobileOrVr"></icon-scroll>
   <div class="instruction-text"><p>
   {{ vrMode ? 'If you are using a VR enabled device, make sure your volume is turned on, then click to enter VR mode and begin the experience. To pause it, look down.' : 'Turn up your volume, then click, drag, and zoom to explore.' }}</p><p>
     <a v-if="iosvr" v-on:click="runVRiOS">Got it.</a>
     <a v-if="onlyiOS" v-on:click="runiOS">Got it.</a>
     <a v-if="onlyvr" v-on:click="runVR">Got it.</a>
     <a v-if="regular" v-on:click="runNormal">Got it.</a></p>
     </div>
</div>
  </div>
  </div>
  </div>
</transition>


  <transition name="fade">
<div class="captioncorner" id="captionContainer" v-show="showCaptions">
  

<div class="caption-box card-panel" id="captions">[...]

</div></div></transition>




    <transition name="fade">

<div class="utility-buttons" id="nav-buttons" v-if="showButtons">
<div id="timing" v-show="isPlaying">
  <span id="current-time">0:00</span>/<span id="duration">5:15</span></div>


           <i class="small material-icons cyan-text text-accent-2" id="captionsIcon" v-on:click="showCaptions = !showCaptions" v-if="!onlyiOS" >closed_caption</i>

         <i class="small material-icons cyan-text text-accent-2" id="pauseIcon" v-on:click="nowPause" >pause_circle_filled</i>

  <i v-on:click="libraryAbout" class="small material-icons cyan-text text-accent-2" >info_outline</i>
<i v-on:click="pressHome" class="small material-icons cyan-text text-accent-2" >home</i>

<div class="progress" id="fish-progress" v-show="isPlaying" >
      <div class="determinate" id="fish-progress-bar"></div>
  </div>
</div>
</transition>

  <story @vrPause="pauseButton" :vrcheck="vrMode" @assetsLoaded="run" :iosCheck="iOS"></story>
   
   
    <transition name="fade">
<about v-if="showAbout" @clicked="libraryAbout"></about>
</transition>



  
        </div>
</template>

<script>
  import { starter, pauseButton, stopButton } from '../fishfade'
  
  import theCaptions from '../captions'

  import About from '@/components/About'
  import IconScroll from '@/components/IconScroll'
  import AnimatedLoader from '@/components/AnimatedLoader'
  import Story from '@/components/Story'

  export default {
    name: 'library',
    beforeMount: function() {
      this.showLoader = true
    },
    mounted:  function() {

      if (!this.vrMode && !this.iOS) {
      this.setUpCaptionsAndProgress()  
}

      }
  ,
    data() {
      return {
        ifPauseClicked: false,
        showAbout: false,
        showLoader: true,
        showInstructions: false,
        showButtons: false,
        showCaptions: false,
        isPlaying: false,
        whichCaption: 0
      }
    },

    methods: {
      pauseButton,
      stopButton,
      setUpCaptionsAndProgress: function() {
       var story = document.getElementById('main-audio')
        story.addEventListener('timeupdate', () => {
        var cTime = story.currentTime
        this.updateTime(cTime)
        this. updateCaptions(cTime)
        this.updateProgress(cTime)

        if (this.isPlaying === false) {
            this.isPlaying = true
          }

          
        })
      },
      updateProgress: function(cTime) {

        var theProgress = cTime/315 * 100
        document.getElementById('fish-progress-bar').style.width = theProgress + '%'
      },
      updateCaptions: function(cTime) {

        cTime = Math.floor(cTime)
        if (cTime < 315 && this.whichCaption < 55) {
        if (cTime === theCaptions[this.whichCaption][0]) {
                var captions = document.getElementById('captions')
          captions.textContent = theCaptions[this.whichCaption][1]
              this.whichCaption+=1
          } 
        }
            if (cTime === 315) {
            this.showCaptions = false
            }
      },
      updateTime: function(currentTime) {
        var seconds = Math.floor(currentTime % 60)
        if (seconds < 10) {
          seconds = "0" + seconds
        }
        var minutes = Math.floor(currentTime / 60)
        document.getElementById('current-time').innerHTML =   minutes + ":" + seconds

},
      pressHome: function() {
              this.stopButton()
                this.$router.push({name: 'home', params: {access: 'given'}})
},
      nowPause: function() {
        this.ifPauseClicked = !this.ifPauseClicked
        this.pauseButton()
      },
      libraryAbout: function() {

        if (!this.ifPauseClicked) {
          this.pauseButton()
        }

        this.showAbout = !this.showAbout

      },
      runNormal: function() {
        this.clearInstructions()
        starter('normal')

      },
      runiOS: function() {
        this.clearInstructions()
        starter('ios')
        //turn on  audio
        var theAudio = document.getElementById('long-audio')
        //consider new file, with a few seconds of ambient
        theAudio.play()

      },
      runVRiOS: function() {
        this.clearInstructions()
        starter('iosvr')
        //turn on audio
        var theAudio = document.getElementById('long-audio')
        theAudio.play()
        var scene = document.querySelector('a-scene');
        scene.enterVR();
      },
      runVR: function() {
        this.clearInstructions()
        starter('vr')
        var scene = document.querySelector('a-scene');
        scene.enterVR();
     },
      clearInstructions: function() {
        this.showInstructions = false
        if (!this.vrMode) {
        this.showButtons = true
        }
      },
      run: function() {
        this.showLoader = false
        this.showInstructions = true

      }
    },
    components: {
      Story, About,
      IconScroll,
      AnimatedLoader
    },
    props: {
      vrMode: Boolean
 },
    computed: {
      mobileOrVr: function() {
        if (this.mobile | this.onlyvr) {
          return true
        }
        return false
      },
      mobile: function() {
        var isMobile = window.matchMedia("only screen and (max-width: 760px)");
        if (isMobile.matches) {
          return true
        }
        return false
      },
      onlyiOS: function() {
        if (this.iOS && !this.vrMode) {
          return true
        }
        return false
      },
      iosvr: function() {
        if (this.iOS && this.vrMode) {
          return true
        }
        return false
      },
      onlyvr: function() {
        if (!this.iOS && this.vrMode) {
          return true
        }
        return false
      },
      regular: function() {
        if (!this.vrMode && !this.iOS) {
          return true
        }
        return false
      },
      iOS: function() {
        var iDevices = [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ];

        if (window.navigator.platform) {
          while (iDevices.length) {
            if (window.navigator.platform === iDevices.pop()) { return true; }
          }
        }

        return false;
      }
    }
  }
</script>
<style>

#timing {    float: left;
    font-size: 50%;
    line-height: 260%;
font-family: 'Major Mono Display', monospace;
}


#timing span {
  margin: 0 5px;
}
.progress {
  position: absolute!important;
    bottom: 0!important;
    margin: 0!important;
    background-color: #76fbfd!important;
}

.determinate {
  background-color: #0B2CF5!important;
  width: 0;

}



.captioncorner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40vw;
  z-index: 1900
}

.caption-box {
  font-family: 'Didact Gothic';
    background: #0B2CF5!important;
    color: #76fbfd;
    line-height: 200%;
    margin: 0!important;
}
  .instructions {
    height: 100vh;
    position: absolute;
    z-index: 899;
    width: 100vw;

  }

  .info-text {
    position: relative;
    top: 85px;
    height: 70px;
  }

  .info-box {
    margin: 25vh auto!important;
    text-align: center;
    background: #0B2CF5!important;
    color: #76fbfd;
    line-height: 200%;
  }


  .utility-buttons {
    position: absolute;
    z-index: 1901;
    cursor: pointer;
    bottom: 0;
    right: 0;
    margin: 10px;
    font-size: 2rem;
    opacity: 1.0;
    transition: opacity 2s;
  }

  .utility-buttons i {
    margin-left: 10px;
  }
</style>
